module.exports = __webpack_public_path__ + "img/dialog-bg.bc39d195.png";